import { api } from '../../plugins/api';
import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const getDefaultState = () => {
	return {
		autreAutorisationsDePratiques: getDefaultValue()
	}
}

const getDefaultValue = () => {
	return {
		membreDUnAutreOrdre: { fileDataDTOs: null },
		demandeAdmission: null,
		demandeInscription: null,
		pp: null,
		numeroDePermisDePsychotherapeuteSiApplicable: "",
		instancesReglementairesEnTravailSocialHorsQuebec: { fileDataDTOs: null },
		active: true
	}
}

const state = getDefaultState()

const getters = {
	GET_AUTRESAUTORISATIONDEPRATIQUES: (state) => { return state.autreAutorisationsDePratiques }
}

const mutations = {
	SET_ID (state, id) {
		state.autreAutorisationsDePratiques.id = id
	},
	SET_CONTACTID (state, id) {
		state.autreAutorisationsDePratiques.pp = id
	},
	SET_DEMANDEADMISSIONID (state, id) {
		state.autreAutorisationsDePratiques.demandeAdmission = id
	},
	SET_DEMANDEINSCRIPTIONID (state, id) {
		state.autreAutorisationsDePratiques.demandeInscription = id
	},
	SET_AUTRESAUTORISATIONDEPRATIQUES (state, dto) {
		if (dto) {
			state.autreAutorisationsDePratiques = { ...dto }
		} else {
			state.autreAutorisationsDePratiques = getDefaultValue()
		}
	},
	resetState (state) {
		Object.assign(state, getDefaultState())
	}
}

const actions = {
	async getAutresAutorisationsDePratiqueByContactId ({ commit }, contactId) {
		const response = await api.get(`autresautorisationsdepratiques/contacts/` + contactId);
		commit("SET_AUTRESAUTORISATIONDEPRATIQUES", response.data)
	},
	async getAutresAutorisationsDePratiqueByDemandeAdmissionId ({ commit }, demandeAdmissionId) {
		const response = await api.get(`autresautorisationsdepratiques/demandesadmissions/` + demandeAdmissionId);
		commit("SET_AUTRESAUTORISATIONDEPRATIQUES", response.data ? response.data[0] : getDefaultValue())
	},
	async getAutresAutorisationsDePratiqueByDemandeInscriptionId ({ commit }, demandeInscriptionId) {
		const response = await api.get(`autresautorisationsdepratiques/demandesinscriptions/` + demandeInscriptionId);
		commit("SET_AUTRESAUTORISATIONDEPRATIQUES", response.data ? response.data[0] : getDefaultValue())
	},
	async createAutresAutorisationsDePratique ({ commit }, pAutresAutorisationsDePratiqueDTO) {
		const response = await api.post(`autresautorisationsdepratiques`, pAutresAutorisationsDePratiqueDTO);
		commit('SET_ID', response.data);
	},
	async getLinkedContactEncryptedId ({ commit }, encryptedId) {
		const response = await api.get(`autresautorisationsdepratiques/${encryptedId}/contact`);
		commit('SET_CONTACTID', response.data);
	},
	async updateAutresAutorisationsDePratique ({ commit }, pAutresAutorisationsDePratiqueDTO) {
		const response = await api.put(`autresautorisationsdepratiques`, pAutresAutorisationsDePratiqueDTO);
		commit('SET_AUTRESAUTORISATIONDEPRATIQUES', response.data);
	},
	getAutresAutorisationsDePratique ({ state }, encryptedId) {
		return api.get(`autorisationsdepratiques/` + encryptedId);
	},
	resetModuleState ({ commit }) {
		commit('resetState')
	},
}

export default ({
	namespaced: true,
	state: state,
	mutations: mutations,
	getters: getters,
	actions: actions
})